import { API_URL } from "../config/api_url";

function getAuthHeaders(extra = {}) {
  const token = localStorage.getItem("access_token");
  return {
    Accept: "application/json",
    Authorization: token ? `Bearer ${token}` : "",
    ...extra,
  };
}

async function readError(res, fallback) {
  try {
    const data = await res.json();
    throw new Error(data?.error || data?.message || fallback);
  } catch {
    const text = await res.text().catch(() => "");
    throw new Error(text || fallback);
  }
}

export async function previewBankStatementExcel(file, bank, bankAccountNumber) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("bank", bank);
  formData.append("bankAccountNumber", bankAccountNumber);

  const res = await fetch(`${API_URL}/bank-statement-excel/preview`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });

  if (!res.ok) {
    await readError(res, "Excel preview failed");
  }

  return res.json();
}

export async function importBankStatementExcel(file, bank, bankAccountNumber) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("bank", bank);
  formData.append("bankAccountNumber", bankAccountNumber);

  const res = await fetch(`${API_URL}/bank-statement-excel/import`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });

  if (!res.ok) {
    await readError(res, "Excel import failed");
  }

  return res.json();
}
